import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { UseMutationOptions, useMutation } from 'react-query'
import { AlmanacFileCalendarItem } from '../calendar/types'

type Props = {
  designId: string
}

type Data = AlmanacFileCalendarItem

export type ReplaceMediaBatchItem = {
  media_file_key: string
  slide_index?: number
  generation_data?: Record<string, unknown>
}

type Variables = {
  replacements: ReplaceMediaBatchItem[]
}

type Options = Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'>

const replaceMediaBatch = async (workspaceId: number, designId: string, replacements: ReplaceMediaBatchItem[]) => {
  const res = await sendToApi(`/w/${workspaceId}/designs/${designId}/replace_media_batch`, {
    method: 'POST',
    body: { replacements },
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data
}

export const useReplaceMediaBatch = ({ designId }: Props, options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()
  return useMutation<Data, Error, Variables>(
    (params) => replaceMediaBatch(workspaceId, designId, params.replacements),
    options,
  )
}
